/* Native Shopify recipient properties for the dedicated digital gift-card form. */
if (!customElements.get('pupring-gift-recipient')) {
    customElements.define('pupring-gift-recipient', class extends HTMLElement {
        connectedCallback() {
            this.toggle = this.querySelector('[data-recipient-toggle]')
            this.fields = this.querySelector('[data-recipient-fields]')
            this.date = this.querySelector('[data-recipient-date]')
            this.form = this.closest('form')
            this.onChange = () => this.sync()
            this.onReset = () => queueMicrotask(() => this.sync())
            this.toggle.addEventListener('change', this.onChange)
            this.form?.addEventListener('reset', this.onReset)
            this.querySelector('[data-recipient-toggle-wrapper]').hidden = false
            this.sync()
        }

        disconnectedCallback() {
            this.toggle?.removeEventListener('change', this.onChange)
            this.form?.removeEventListener('reset', this.onReset)
        }

        sync() {
            const enabled = this.toggle.checked
            this.fields.hidden = !enabled
            this.fields.disabled = !enabled
            // Disable each control too, keeping serialization safe in custom cart paths.
            this.fields.querySelectorAll('input, textarea').forEach(input => { input.disabled = !enabled })
            this.toggle.setAttribute('aria-expanded', String(enabled))
            const today = new Date()
            const latest = new Date(today)
            latest.setDate(latest.getDate() + 90)
            const localDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
            this.date.min = localDate(today)
            this.date.max = localDate(latest)
            this.querySelector('[data-recipient-offset]').value = String(today.getTimezoneOffset())
        }
    })
}
